import { Button, Icon } from '@rodeo-dev/legos'
import PropTypes from 'prop-types'
import React from 'react'
import IntlUtil from '../../../lib/intlutil.jsx'

const PayButton = ({
  loading = false,
  onClick,
  labelId = 'setting.subscription.payButtonLabel'
}) => (
  <Button
    color='primary'
    onClick={onClick}
    disabled={Boolean(loading)}
    startIcon={<Icon prefix='fas' color='inherit' icon='shopping-cart' />}
  >
    {IntlUtil.convertMessage(labelId)}
  </Button>
)

PayButton.propTypes = {
  loading: PropTypes.bool,
  onClick: PropTypes.func.isRequired,
  labelId: PropTypes.string
}

export default PayButton
